export enum DataTableConst {
    location = 'location',
    noresult = 'No results found',
    equipmentLocation = 'equipmentLocation'
}
